import { hasForms2 } from "../../js/helpers";

(function ($) {
    $(document).ready(() => {
        $('[block-name="branded-subscribe"]').each((index, block) => {
            const form = $(block).find('form');
            const id = form.attr('data-form-id');

            if (!id || !hasForms2()) {
                return;
            }

            MktoForms2.loadForm("//app-sn03.marketo.com", "091-LWC-058", id);
            MktoForms2.whenReady(function () {
                form.removeClass('loading');
            });

            MktoForms2.whenReady(function (mktoForm) {
                mktoForm.onSuccess(function (values, followUpUrl) {
                    const url = (typeof followUpUrl === 'string' && followUpUrl.trim().length > 0)
                        ? followUpUrl.trim()
                        : '';

                    if (followUpUrl && new URL(followUpUrl, location.href).pathname !== location.pathname) {
                        setTimeout(function () {
                            window.location.assign(url);
                        }, 5000);
                    }

                    return false;
                });
            });
        });
    });
})(jQuery);
